import Button from "@app/sharedComponents/Button/Button";
import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader";
import { themeColorSet, ThemedText, ThemedView } from "@app/theme";
import { formatIndianCurrency } from "@app/utils/utility";
import dayjs from "dayjs";
import {CaretRight} from "@app/sharedComponents/Icons/Icons";
import CreditCash from '../../../assets/Icons/CreditCash';
import ZeroCash from '../../../assets/Icons/ZeroCash';
import CreditHealth from '../../../assets/Icons/CreditHealth';
import { ScrollView } from "react-native";
import { useEffect, useState } from "react";
import axios from "axios";
import { endpoints } from "@app/api/apis";
import {  useAppDispatch, useAppSelector } from "@app/store/hooks";
import BottomSheetContainer from "@app/sharedComponents/Bottomsheet/Bottomsheet";
import VerificationOTP from "@app/sharedComponents/VerificationOTP/VerificationOTP";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { BottomTabParamList, PrivateStackParamList } from "@app/navigationApp/types";
import ROUTE from "@app/navigationApp/routes";
import fetchUserDetails from "@app/helper/fetchUserInfo";
import handleApiErr from "@app/helper/handleApiErr";
import { showErrorSheet } from "@app/store/slices/errorSlice";

type LoanDetails = {
    expiryDate?: number;
    actualLoanAmount?: number;
    loanDetails?: {
        actualLoanAmount?: number;
        expiryDate?: number;
        remainingTenureInDays?: number;
        lenderCreditId?: string;
        totalValueOfAssetsPledged?: number;
    }
    interestDetails?: {
        interestRate?: number;
    }
    // Add other properties as needed
};

type ScreenProps = NativeStackScreenProps<PrivateStackParamList & BottomTabParamList , 'CONFIRM_LOAN_DETAILS'>;


const ConfirmLoanDetails = ({navigation} : ScreenProps)=>{

    const foreCloseReason = useAppSelector((state) => state.commonReducer.foreCloseReason);
    const userDetails = useAppSelector((state) => state.auth.userDetails);
    const [loanDetailsObj,setLoanDetailsObj] = useState<LoanDetails | null>(null);
    const [isBottomSheetVisible,setIsBottomSheetVisible] = useState(false);
    const [isButtonLoading,setIsButtonLoading] = useState(false);
    const dispatch = useAppDispatch()
    const getLoanDetails = ()=>{
        const url = endpoints.loanDetails + userDetails?.linkedCredits[0]?.creditId
        axios.get(url).then((res)=>{
            setLoanDetailsObj(res?.data)
        })  
        .catch((err)=>{
            console.log('err',err)
        })
    }

    const handleForeclosure = () => {
        // navigation.navigate(ROUTE.REPAY_DUES);
        // return
        setIsButtonLoading(true)
        const {creditId} = userDetails?.linkedCredits[0];
        const payload ={
            creditId,
            ...foreCloseReason
        }
        axios.post(endpoints.initiateForeclosure, payload)
        .then((res)=>{
            openBottomSheet();
        }
        ).catch((err)=>{
            console.log('initiateForeclosure',err)
            if(handleApiErr(err)){
                dispatch(showErrorSheet({
                    isErrorSheetVisible: true,
                    errorMessage: err?.data?.message,
                    closeOnBackdropPress: true,
                    errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
                    errorHeading:  err?.data?.header,
                    showErrorHeading: true,
                    btnName:'Ok, got it!',
                }))
            }
        }).finally(()=>{
            setIsButtonLoading(false)
        })
    }

    useEffect(()=>{
        getLoanDetails();
    }, []);

    const closeBottomSheet = () => {
        setIsBottomSheetVisible(false);
    }

    const openBottomSheet = () => {
        setIsBottomSheetVisible(true);
    }


    const onVerificationSuccess = (data:any)=>{
        setIsBottomSheetVisible(false);
        fetchUserDetails()
        setTimeout(()=>{
            navigation.navigate(ROUTE.DASHBOARD_SCREEN);
        },500)
    }



    return(
        <ThemedView flex={1} backgroundColor="bg-surface-primary">
        <PageHeaders pageName="ConfirmLoanDetails" label="Confirm Loan Details" navigation={navigation}/>        
        <ScrollView style={{flex:1,backgroundColor:themeColorSet["bg-surface-page"]}}>
            <ThemedText variant="h5b" color="text-primary" p="lg" mt="lg" >Loan details</ThemedText>
            <ThemedView backgroundColor="bg-surface-primary" borderTopWidth={1} borderBottomWidth={1} borderColor="border-primary" p="lg">
                <ThemedView flexDirection="row" justifyContent="space-between" >
                    <ThemedText variant="b3r" color="text-primary">Loan account number</ThemedText>
                    <ThemedText variant="b3s" color="text-primary">{loanDetailsObj?.loanDetails?.lenderCreditId}</ThemedText>
                </ThemedView>
                <ThemedView width={'100%'} height={1} backgroundColor="border-primary" my="md" />
                <ThemedView flexDirection="row" justifyContent="space-between" >
                    <ThemedText  variant="b3r"color="text-primary">Loan amount</ThemedText>
                    <ThemedText variant="b3s"  color="text-primary">₹{formatIndianCurrency(loanDetailsObj?.loanDetails?.actualLoanAmount)}</ThemedText>
                </ThemedView>
                <ThemedView width={'100%'} height={1} backgroundColor="border-primary" my="md" />
                <ThemedView flexDirection="row" justifyContent="space-between" >
                    <ThemedText  variant="b3r"color="text-primary">End date</ThemedText>
                    <ThemedText  variant="b3s" color="text-primary">{dayjs(loanDetailsObj?.loanDetails?.expiryDate).format('DD MMM YYYY')}</ThemedText>
                </ThemedView>
                <ThemedView width={'100%'} height={1} backgroundColor="border-primary" my="md" />
                <ThemedView flexDirection="row" justifyContent="space-between" >
                    <ThemedText variant="b3r" color="text-primary">Interest rate</ThemedText>
                    <ThemedText variant="b3s"  color="text-primary">{loanDetailsObj?.interestDetails?.interestRate}%</ThemedText>
                </ThemedView>
            </ThemedView>
            <ThemedText variant="h5b"  color="text-primary" p="lg" mt="md" >Collateral details</ThemedText>
            <ThemedView  backgroundColor="bg-surface-primary" borderTopWidth={1} borderBottomWidth={1} borderColor="border-primary" p="lg" justifyContent="space-between" flexDirection="row">
                <ThemedView>
                    <ThemedText variant="b4r" color="text-secondary">Mutual fund value</ThemedText>
                    <ThemedText variant="b3b" color="text-primary">₹{formatIndianCurrency(loanDetailsObj?.loanDetails?.totalValueOfAssetsPledged)}</ThemedText>
                </ThemedView>
                <Button type="TEXT" handlePress={()=>{navigation.navigate(ROUTE.VIEW_DETAILS)}} label="View details" showRightAccessory={true} rightAccessory={()=> <CaretRight size="16" color={themeColorSet['text-action-primary']} />}/>
            </ThemedView>
            <ThemedText variant="h5b" color="text-primary" p="lg" mt="md" >Benefits you lose if you close account</ThemedText>
            <ThemedView mb="xl" backgroundColor="bg-surface-primary" borderTopWidth={1}  borderColor="border-primary" p="lg">
                <ThemedView flexDirection="row" alignItems="center">
                    <CreditCash/>
                    <ThemedText color="text-secondary" variant="b3m" ml="sm">Instant access to ₹{formatIndianCurrency(loanDetailsObj?.loanDetails?.actualLoanAmount)} - ready whenever you need it in emergency</ThemedText>
                </ThemedView>
                <ThemedView my="xl" width={'100%'} height={1} backgroundColor="border-secondary"/>
                <ThemedView flexDirection="row" alignItems="center">
                    <ZeroCash/>
                    <ThemedText color="text-secondary"  variant="b3m" ml="sm">No charges or interest when you don't use your credit line</ThemedText>
                </ThemedView>
                <ThemedView my="xl" width={'100%'} height={1} backgroundColor="border-secondary"/>
                <ThemedView flexDirection="row" alignItems="center">
                    <CreditHealth/>
                    <ThemedText color="text-secondary"  variant="b3m" ml="sm">Opportunity to improve your credit health</ThemedText>
                </ThemedView>
            </ThemedView>
        </ScrollView>
        <ThemedView backgroundColor="bg-surface-primary" p="lg" borderTopWidth={1} borderTopColor="border-primary">
            <Button type="SOLID" label="Confirm with OTP" handlePress={handleForeclosure} buttonLoader={isButtonLoading}/>
        </ThemedView>
        <BottomSheetContainer
            isVisible={isBottomSheetVisible}
            close={closeBottomSheet}
            closeOnBackdropPress={true}
            borderTopRightRadius={10}
            borderTopLeftRadius={10}
            containerStyle={{ backgroundColor: '#fefefe' }}
            showCloseIcon={true}
            onClose={closeBottomSheet}
        >
            <VerificationOTP 
                heading="Enter OTP to confirm"
                otpType="PHONE_NUMBER"
                otpSentTo={userDetails?.user?.phoneNumber}
                otpDigitCount={6}
                resendUrl={endpoints?.initiateForeclosure} 
                apiPayload={{creditId : userDetails?.linkedCredits[0].creditId}} 
                verifyUrl={endpoints?.verifyForeclosure}
                attributeKeyToVerify={'phoneNo'}
                attributeValueToVerify={userDetails?.user?.phoneNumber}
                onClose={closeBottomSheet}
                onVerificationSuccess={onVerificationSuccess}
                resendApiMethod={"POST"}          
            />
        </BottomSheetContainer>
        </ThemedView>
    )
}

export default ConfirmLoanDetails;